import React, { useEffect } from 'react';

const Product7 = () => {
const images = [
{
src: "https://www.laser-ndt.com/assets/img/banners/energy_banner.webp",
alt: "High-Resolution Microscope",
caption: "Microscopic laser inspection for precision measurements"
},
{
src: "https://www.laser-ndt.com/assets/img/pic1.webp",
alt: "BEMIS LC Inspection",
caption: "BEMIS LC system inspecting large-caliber gun bores"
},
{
src: "https://www.laser-ndt.com/assets/img/pic2.webp",
alt: "Hall Thruster Mapping",
caption: "Erosion mapping of space thrusters using laser scanning"
},
{
src: "https://www.laser-ndt.com/assets/img/banners/defense_banner.webp",
alt: "Gun Bore Visualization",
caption: "Visualizing internal gun bore conditions with laser imaging"
},
{
src: "https://www.laser-ndt.com/assets/img/nuclear.webp",
alt: "Nuclear Inspection",
caption: "Under water nuclear Inspection"
},
{
src: "https://www.laser-ndt.com/assets/img/pic10.webp",
alt: "Custom Inspection System",
caption: "Tailored laser setup for specialized industrial inspection"
}
];

useEffect(() => {
window.scrollTo(0, 0);
}, []);

return (
<div className="p-10 bg-black text-white">
<h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black animate-slide-in">
Laser Techniques Company, LLC
</h1>

  <div className="space-y-12">
    {/* Company Overview */}
<section className="flex flex-col lg:flex-row items-center lg:space-x-8">
  <div className="lg:w-1/2 mb-6 lg:mb-0">
  <div className="relative w-full max-h-[400px] rounded-lg shadow-xl overflow-hidden aspect-video">
    <iframe
      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7285711250670395393?compact=1"
      title="LinkedIn Video"
      frameBorder="0"
      allowFullScreen
      className="absolute top-0 left-0 w-full h-full"
    />
  </div>
</div>


  <div className="lg:w-1/2">
    <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
      Company Overview
    </h3>
    <p className="text-lg leading-relaxed hover:scale-105 hover:text-gray-200 transition duration-500">
      Laser Techniques Company, LLC (LTC) delivers high-resolution, non-contact laser
      inspection systems for aerospace, defense, and energy sectors. With more than
      two decades of innovation, LTC’s technologies such as BEMIS™ and Laser MicroMap™
      enable 3D imaging, surface mapping, and defect detection with superior accuracy
      and speed.
    </p>
  </div>
</section>


   {/* Bore Inspection & Profiling Systems */}
<section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
  <div className="lg:w-full">
    <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
      Bore Inspection & Profiling Systems
    </h3>
    <p className="text-lg leading-relaxed mb-4 hover:text-gray-200 transition duration-500">
      Laser Techniques Company's BEMIS™ (Bore Erosion Measurement and Inspection System) provides high-resolution, laser-based profiling for gun bores and similar structures. Trusted by military organizations, BEMIS supports erosion detection, calibration, and operational maintenance with real-time 3D scan data.
    </p>

    <h4 className="text-2xl font-semibold mt-6 mb-2">Versatile Applications</h4>
    <ul className="list-disc list-inside text-lg mb-4">
      <li><strong>BEMIS-SC™</strong> — Small Caliber (5.56mm to 12.7mm)- Stationary</li>
      <li><strong>BEMIS-MC™</strong> — Medium Caliber (12.7mm to 76mm)- Stationary and Portable</li>
      <li><strong>BEMIS-LC™</strong> — Large Caliber (105mm to 155mm)- Stationary and Portable</li>
    </ul>

    <h4 className="text-2xl font-semibold mt-6 mb-2">Advanced Features</h4>
    <ul className="list-disc list-inside text-lg mb-4">
      <li>Non-contact, laser-based measurement with thousands of samples per scan</li>
      <li>3D precision profiling and high-resolution bore mapping</li>
      <li>LaserVideo™ imaging for visualizing bore surface features</li>
      <li>Automated analysis and reporting with exportable data options</li>
    </ul>

    <h4 className="text-2xl font-semibold mt-6 mb-2">Operational Efficiency</h4>
    <ul className="list-disc list-inside text-lg mb-4">
      <li>Fast setup with automatic calibration routines</li>
      <li>Adaptable sensors for various calibers and conditions</li>
      <li>Portable and rugged design for field and shop use</li>
    </ul>

  </div>
</section>
<section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8 px-6 py-10 bg-black text-white">
<div className="lg:w-1/2 mb-6 lg:mb-0 flex flex-col items-center text-center">
  <img
    src="https://media.licdn.com/dms/image/v2/D5622AQHsZN6c9M1F8A/feedshare-shrink_800/B56ZaMphMKHAAg-/0/1746116416629?e=1772064000&v=beta&t=P31TbPPJ7FWt7NY6pthlbMH3mpqIMXxVQazRUEP6ZMU"
    alt="LaserViewer Software Screenshot"
    className="w-full max-w-xl rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
  />
  <p className="text-lg leading-relaxed mt-4 max-w-xl hover:text-gray-200 transition duration-500">
    LaserViewer™ is Laser Techniques Company's proprietary Windows™-based software designed for high-precision laser profilometry and advanced visual inspection. Bundled with the LP-5000™, the platform supports multi-channel laser data acquisition, LaserVideo™ imaging, straightness measurement, and FPI scanning — delivering real-time, distortion-free visualization.
  </p>
</div>

  {/* Text Section */}

  <div className="lg:w-1/2 space-y-6">
  <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
      LaserViewer™ Software Suite
    </h3>

    <div>
      <h3 className="text-2xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-white to-cyan-400">
        Core Capabilities
      </h3>
      <ul className="list-disc list-inside text-lg leading-relaxed">
        <li>LaserViewer™ 3D and Advanced Analysis modules</li>
        <li>LaserVideo™ imaging with high fidelity surface reflectance mapping</li>
        <li>Custom report generation with exportable data sets</li>
      </ul>
    </div>

    <div>
      <h3 className="text-2xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-white to-cyan-400">
        Customizable Interface
      </h3>
      <ul className="list-disc list-inside text-lg leading-relaxed">
        <li>Operator-specific GUI configurations for simplified workflows</li>
        <li>Application-focused display and analysis modules</li>
      </ul>
    </div>

    <div>
      <h3 className="text-2xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-white to-cyan-400">
        Motion Control
      </h3>
      <ul className="list-disc list-inside text-lg leading-relaxed">
        <li>Support for 3-axis motion using stepper or DC servo motors</li>
        <li>Configurable scan patterns: helical, raster, incremental & contour-following</li>
        <li>Resolution down to 0.0005 inches per increment</li>
        <li>Full encoder support and routines (Jog, Go-To, etc.)</li>
      </ul>
    </div>

    <div>
      <h3 className="text-2xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-white to-cyan-400">
        Advanced Data Acquisition
      </h3>
      <ul className="list-disc list-inside text-lg leading-relaxed">
        <li>Real-time, calibrated C-scan and profile imaging</li>
        <li>Support for axial, cross-sectional, and contour display modes</li>
        <li>Dynamic color palettes: Rainbow, Grayscale, Thermal, Solid</li>
        <li>Post-processing: filtering, offset corrections, ovality, area & diameter calculations</li>
        <li>Interactive tools: pan, zoom, rotate, and color overlays</li>
      </ul>
    </div>
  </div>
</section>


<section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
  {/* Image + Description Block */}
  <div className="lg:w-1/2 mb-6 lg:mb-0 flex flex-col items-center text-center">
    <img
      src="https://image.slidesharecdn.com/ltcadsheet-130827182047-phpapp01/75/Laser-Techniques-Company-Bore-Erosion-Measurement-Inspection-System-1-2048.jpg"
      alt="Bore Analysis Report Generator Screenshot"
      className="w-full max-w-xl rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
    />
    <p className="text-lg leading-relaxed mt-4 max-w-xl hover:text-gray-200 transition duration-500">
      Laser Techniques Company's Bore Analysis Report Generator Software is an advanced PC-based tool designed to interpret and visualize detailed laser scan data from BEMIS™ systems. It generates precise, user-configurable reports for military-grade bore inspection and profiling tasks.
    </p>
  </div>

  {/* Textual Content Block */}
  <div className="lg:w-1/2">
    <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
      Bore Analysis Report Generator Software
    </h3>

    <h4 className="text-2xl font-semibold mt-6 mb-2">Integrated with LaserViewer™</h4>
    <ul className="list-disc list-inside text-lg mb-4">
      <li>Seamless compatibility with LaserViewer™, LaserViewer™ 3D, and Advanced Analysis modules</li>
      <li>Supports all BEMIS™ model outputs and scan formats</li>
    </ul>

    <h4 className="text-2xl font-semibold mt-6 mb-2">Comprehensive Bore Geometry Analysis</h4>
    <ul className="list-disc list-inside text-lg mb-4">
      <li>Calculation of land and groove diameters at each axial location</li>
      <li>Max, min, and average land/groove width and depth metrics</li>
      <li>Bore runout computation based on rifling symmetry and center alignment</li>
    </ul>

    <h4 className="text-2xl font-semibold mt-6 mb-2">Rifling Twist & Surface Metrics</h4>
    <ul className="list-disc list-inside text-lg mb-4">
      <li>Cumulative angular twist and twist rate analysis</li>
      <li>Surface angle and contour mapping across the bore</li>
    </ul>
  </div>
</section>



    {/* Applications Section */}
    <section className="text-center">
      <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
        Applications and Capabilities
      </h3>
      <ul className="list-disc list-inside text-lg space-y-4 hover:text-gray-300 transition">
        <li><strong>Defense:</strong> Gun bore erosion mapping (5.56mm to 155mm) and mortar tube inspection.</li>
        <li><strong>Aerospace:</strong> Surface inspection and thruster chip detection.</li>
        <li><strong>Energy:</strong> Steam generator tube mapping for nuclear facilities.</li>
        <li><strong>Software:</strong> LaserViewer™ for visualization, analysis, and motion control.</li>
        <li><strong>Customization:</strong> Modular setups tailored to client-specific inspection needs.</li>
      </ul>
    </section>

    {/* Image Gallery with Captions */}
    <section className="mt-10">
      <h3 className="text-3xl font-semibold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black text-center">
        Our Technology in Action
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {images.map((image, index) => (
          <div key={index} className="relative group overflow-hidden rounded-xl shadow-lg">
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-64 object-cover transform transition duration-500 group-hover:scale-110 group-hover:opacity-85"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center px-4 text-center">
              <span className="text-white text-md font-medium">{image.caption}</span>
            </div>
          </div>
        ))}
      </div>
    </section>

    {/* Contact */}
    <section className="mt-12 text-center">
      <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
        Contact Us
      </h3>
      <p className="text-lg">
        For inquiries, custom solutions, or partnership opportunities, reach out to us at:{' '}
        <a href="mailto:rambomble@alphaq.co.in" className="text-blue-500 hover:text-blue-700 transition-colors duration-300">
          rambomble@alphaq.co.in
        </a>
      </p>
    </section>
  </div>
</div>
);
};

export default Product7;